import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from 'history';

import * as layouts from './layouts/layouts';

import Landing from './pages/Landing';
import ContactUs from "./pages/ContactUs";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Terms from "./pages/Terms";
import Study from "./pages/Study";
import ReactGA from 'react-ga4';
import * as authFns from './functions/auth';

import GDPRPrompt from './components/landing/GDPRConsent';

const logPageView = () => {
	// ReactGA.set({ page: window.location.pathname + window.location.search });
	// ReactGA.pageview(window.location.pathname + window.location.search);
	ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: "Routes Title" });
};

// https://tylermcginnis.com/react-router-protected-routes-authentication/
const PrivateRoute = ({ component: Component, ...rest }) => (

	// TODO: need to handle partner urls -- don't want to send them to login

	<Route {...rest} render={(props) => (
		authFns.canAccessPrivate()
			? <Component {...props} />
			: <Redirect to={{
				pathname: '/login',
				state: { from: props.location }
			}} />
	)} />
);

const PublicRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={(props) => (
		authFns.canAccessPublic()
			? <Component {...props} />
			: <Redirect to={{
				pathname: '/unavailable',
				state: { from: props.location }
			}} />
	)} />
);

const Routes = (
	<Router history={createBrowserHistory} onUpdate={logPageView}>
		<div className="pilotly-routes">
			<Switch>
				<PublicRoute path="/login" component={layouts.LoginLayout} />
				<PublicRoute path="/logout" component={layouts.LogoutLayout} />
				<PublicRoute path="/register" component={layouts.RegisterLayout} />
				<PublicRoute path="/forgot-password" component={layouts.ForgotPasswordLayout} />
				<PublicRoute path="/reset-password" component={layouts.ResetPasswordLayout} />
				<PublicRoute path="/process-target" component={layouts.ProcessTargetLayout} />
				<PublicRoute path='/tech-check' component={layouts.TechCheckLayout} />
				<Route path='/contact-us' component={ContactUs} />
				<Route path='/privacy-policy' component={Privacy} />
				<Route path='/cookie-policy' component={Cookies} />
				<Route path='/terms-and-conditions' component={Terms} />

				<PublicRoute path="/viewer-select" component={layouts.PanelSegmentSelectLayout} />
				<PublicRoute path="/security" component={layouts.SecurityLayout} />
				<PublicRoute path='/mobile-redirect' component={layouts.MobileRedirectLayout} />
				<PublicRoute path="/video-disclaimer" component={layouts.VideoDisclaimerLayout} />
				<PublicRoute path="/viewer-consent" component={layouts.ViewerConsentDisclaimerLayout} />

				<PrivateRoute path="/mpaa" component={layouts.MPAAWarningLayout} />
				<PublicRoute path="/feedback" component={layouts.FeedbackLayout} />
				<PrivateRoute path='/study' component={Study} />
				<PrivateRoute path='/home' component={layouts.HomeLayout} />
				<PrivateRoute path='/mylist' component={layouts.HomeLayout} />
				<PrivateRoute path='/rewards' component={layouts.HomeLayout} />
				<PrivateRoute path='/profile' component={layouts.HomeLayout} />

				<Route exact path='/unavailable' component={layouts.UnavailableLayout} />
				<Route exact path='/non-partner-restricted' component={layouts.NonPartnerRestrictedLayout} />

				<PublicRoute exact path='/' component={Landing} />
				<PublicRoute component={layouts.NotFoundLayout} />
				
				{/* <Route path='/404' component={layouts.NotFoundLayout} />
				<Redirect to="/404" /> */}
			</Switch>
			<GDPRPrompt/>
		</div>
	</Router>
);

export default Routes;


// WEBPACK FOOTER //
// ./src/Routes.js